<template>
  <div class="content-tab aggretrunking">
    <loading :mask=true :size="'big'" :isWhite=true v-if="isShowLoading"/>
    <div class="content-body">
      <div class="content-item">
        <div class="describe">{{$t('lag.describe')}}</div>
        <!-- <div class="content-body-header">
          <button class="q-button blue-btn-full footer-btn" :title="$t('add')" @click="onActionClick('add')">{{$t('add')}}</button>
        </div> -->
        <div class="note">
          <icon-remind class="remind"></icon-remind>
          <span class="title">{{$t('vlan.boundingNote')}}</span>
        </div>
        <div class="group-table" v-if="groups.length > 0">
          <fixed-table ref="groupTable" :data="groups" :use-page="false" :header-height="40">
            <div class="right-header" slot="right-header">
              <column style="width: 18%;">
                <div class="slash" :data-text="$t('group')"></div>
                <div class="title">{{$t('port.portnumber')}}</div>
              </column>
              <column class="portNo" v-for="num in portNumber" :key="num" :style="{ width: (56 / portNumber)+'%' }">{{num}}</column>
              <column :id="$t('lag.mode')" :title="this.$isOverflow($t('lag.mode'))" style="width: 10%;">{{$t('lag.mode')}}</column>
              <column style="width: 16%;">{{$t('action')}}</column>
            </div>
            <template slot="rows" slot-scope="props">
              <div class="link-row">
                <row class="right" :props="props">
                  <div class="data group-id" style="width: 18%;">{{getKey(props.data.key)}}</div>
                  <div class="data portNo" :style="{ width: (56 / portNumber)+'%' }" v-for="index in portNumber" :key="index">
                    <div class="q-icon icon-tick" v-if="getPortMembers(props.data.val.PortMembers, index)">
                    </div>
                  </div>
                  <div class="data mode" style="width: 10%;">{{getLACPtype(props.data.val.AggrMode)}}</div>
                  <div class="data action" style="width: 16%;">
                    <div class="icon-edit" :title="$t('edit')" @click="onActionClick('edit',props.data)"/>
                    <div class="icon-trashcan" :title="$t('clear')" @click="onActionClick('clear',props.data)" :disabled="props.data.val.PortMembers.length === 0"/>
                  </div>
                </row>
              </div>
            </template>
          </fixed-table>
        </div>
        <div class="empty" v-else>
          <nodata/>
          <div class="content-text">{{$t('empty')}}</div>
        </div>
      </div>
    </div>
    <popup-confirm name="laggr-modal" :dialog-header="$t('lag.clear')" :dialog-message="$t('lag.deleteGroup')" icon="w" :callback="goClear" type="c"/>
    <popup-confirm name="vlan-warning-modal" :dialog-header="$t('warning')" :dialog-message="$t('vlan.manageEmpty', {0: manageMentVlan})" icon="w" :onlyOk=true type="c"/>
    <LacpItem :type=actionType :selectItem=selectObject :onChange="getGroup" :existNum="this.inUse"></LacpItem>
    <v-dialog/>
    <popup-confirm name="lacp-warning-modal" :dialog-header="$t('warning')" :dialog-message="$t('lag.groupLimit')" icon="w" :onlyOk=true ></popup-confirm>
  </div>
</template>

<script>
import config from '../config'
import fixedTable from './table/FixedTable'
import row from './table/row/Row'
import column from './table/column/Column'
import LacpItem from './LacpItem'
import iconRemind from '../assets/svg/ic_system_remind.svg'
import nodata from '../assets/svg/no_data.svg'
import {
  mapState,
  mapMutations,
  mapActions
} from 'vuex'

export default {
  name: 'Lacp',
  components: {
    fixedTable,
    row,
    column,
    LacpItem,
    iconRemind,
    nodata
  },
  data () {
    return {
      aggrMode: config.constant.AggrMode,
      groups: [],
      inUse: {port: [], key: []},
      selectObject: null,
      deleteGroupObj: [],
      cellSelectList: [],
      actionType: '',
      isShowLoading: false,
      vlanList: [],
      manageMentVlan: '1'
    }
  },
  created: async function () {
    let me = this
    window.addEventListener('resize', this.myEventHandler)
    setTimeout(() => {
      me.$forceUpdate()
    }, 500)
  },
  watch: {
    currentUser: {
      handler (value) {
        if (value && value.auth !== undefined) {
          this.getGroup()
        }
      },
      immediate: true,
      deep: true
    },
    lang: {
      handler (value) {
        let me = this
        setTimeout(() => {
          me.$forceUpdate()
        }, 500)
      },
      immediate: true
    }
  },
  methods: {
    getGroup: function () {
      this.isShowLoading = true
      this.inUse.key = []
      this.inUse.port = []
      this.getLagStatus()
        .then(res => {
          if (res.data && res.data.error_code === 200) {
            let data = []
            res.data.result.forEach(element => {
              if (Number(element.key) <= this.lagGroupMap.size) {
                data.push(element)
                this.inUse.key.push(parseInt(element.key))
                element.val.PortMembers.forEach(port => {
                  this.inUse.port.push(parseInt(port))
                })
              }
            })
            this.groups = data
            this.isShowLoading = false
          }
        })
        .catch(error => {
          this.$log.error(error)
        })
    },
    getKey: function (data) {
      return this.$t('lag.groupName') + ' ' + data
    },
    getPortMembers: function (members, number) {
      if (members.length > 0) {
        let index = members.indexOf('' + number)
        if (index > -1) {
          return true
        } else {
          return false
        }
      } else {
        return false
      }
    },
    getLACPtype: function (type) {
      let result = ''
      switch (type) {
        case 1:
          result = this.$t('lag.LACP')
          break
        case 2:
          result = this.$t('mactable.static')
          break
        default:
          result = '--'
      }
      return result
    },
    onActionClick: function (status, data) {
      this.selectObject = {}
      if (status === 'edit') {
        this.actionType = 'edit'
        this.selectObject = Object.assign({}, this.selectObject, data)
        this.$modal.show('lacp-item-modal')
      } else if (status === 'clear') {
        this.getVlan().then((res) => {
          this.vlanList = res.data.result
          if (this.checkManageMent(data.key) && this.checkLagMember(data.key)) {
            this.$modal.show('vlan-warning-modal')
          } else {
            this.$modal.show('laggr-modal')
            this.deleteGroupObj = {
              key: data.key,
              val: {
                PortMembers: [],
                AggrMode: 3
              }
            }
          }
        })
      }
    },
    goClear: function () {
      var me = this
      this.$modal.hide('laggr-modal')
      this.isShowLoading = true
      this.setLagStatus(this.deleteGroupObj).then(result => {
        me.cellSelectList = []
        me.groups = []
        me.deleteGroupObj = []
        me.getGroup()
      })
    },
    checkManageMent (key) {
      let result = false
      let lagNum = parseInt(key) + parseInt(this.lagStartNum)
      let manageMentList = []
      this.vlanList.forEach((item) => {
        if (item.key === this.manageMentVlan) manageMentList = item
      })
      manageMentList.val.forEach((item) => {
        if (parseInt(lagNum) === parseInt(item.Port)) result = true
      })
      return result
    },
    checkLagMember (key) {
      let me = this
      let lagNum = parseInt(key) + parseInt(this.lagStartNum)
      let isNotLastOneMember = false
      let hasPorts = false
      let manageMentList = []
      this.vlanList.forEach((item) => {
        if (item.key === this.manageMentVlan) manageMentList = item
      })
      manageMentList.val.forEach((members) => { // only handle management vlan
        if (manageMentList.val.length > 1) { // if management vlan has other mamber
          if (parseInt(members.Port) > parseInt(this.lagStartNum)) { // check is trunk port or not
            if (parseInt(members.Port) !== lagNum) { // except current lag
              if (me.groups[parseInt(members.Port) - (1 + parseInt(me.lagStartNum))].val.PortMembers.length > 0) { // confirm lacp has members
                isNotLastOneMember = true
              }
            }
          } else {
            hasPorts = true
          }
        }
      })
      return !(isNotLastOneMember || hasPorts)
    },
    myEventHandler (e) {
      this.$forceUpdate()
    },
    ...mapActions(['getLagStatus', 'setLagStatus', 'getVlan']),
    ...mapMutations(['openModal', 'closeModal'])
  },
  computed: {
    ...mapState({
      lang: state => state.app.lang,
      portNumber: state => state.module.portNum,
      currentUser: state => state.module.currentUser,
      lagGroupMap: state => state.module.lagGroupMap,
      lagStartNum: state => state.module.lagStartNum
    })
  }
}
</script>

<style lang="scss" scoped>

@import '../assets/scss/login.scss';

.content-tab.aggretrunking {
  position: relative;
  border-bottom-left-radius: 4px;
  border-bottom-right-radius: 4px;
  .content-body {
    padding: 10px;
    .content-body-header {
      padding-bottom: 10px;
      display: flex;
      justify-content: flex-end;
    }
    .content-item {
      height: inherit;
      >.note {
        font-family: 'Roboto-R';
        font-size: 14px;
        color: #195A87;
        text-align: left;
        line-height: 18px;
        margin: 10px 0px 20px 0px;
        svg {
          vertical-align: top;
        }
        .remind {
          width: 16px;
          height: 18px;
          margin-right: 10px;
        }
      }
    }
    .empty {
      text-align: center;
      svg {
        width: 150px;
        height: 150px;
      }
      >div {
        margin: auto;
        font-family: 'Roboto-M' !important;
        font-size: 16px;
      }
    }
    .add {
      margin-bottom: 20px;
    }
    .group-table {
      height: calc(100% - 100px);
      .link-row >.right{
        >.data {
          padding: 0px;
          &.action {
            display: inherit;
            margin: auto;
            padding-left: 16px;
            .icon-trashcan {
              margin-left: 15px;
            }
          }
          &.group-id {
            text-align: center;
          }
          &.portNo {
            border-right: #F1F1F1;
            .q-icon {
              width: 20px;
              height: 20px;
              margin: 7px auto;
              fill: #000000;
            }
          }
          &.mode {
            padding-left: 16px;
          }
        }
      }
      .right-header {
        >.qweb-column:first-child {
          padding-left: 0px;
        }
        .title {
          position: absolute;
          display: inline-block;
          right: 10px;
        }
        .slash {
          position:relative;
          display: inline-block;
          width: 100%;
          height: 100%;
          &:before {
            content: attr(data-text);
            position:absolute;
            left:0px;
            top:0;
            right:0;
            bottom:0;
            -webkit-clip-path: polygon(0 0, 0 100%, 230% 225%, 0 0);
            clip-path: polygon(0 0, 0 100%, 230% 225%, 0 0);
            background:#fff;
          }
        }
      }
    }
    .qweb-column.portNo {
        text-align: center;
        padding: 0px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Lacp.vue